import React, { useContext, useEffect, useRef } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import DialogModel from "../../../../models/dialogMoel";
import {
  BasicContainer,
  Title,
  Text,
  IconDiv,
  Remark,
  StyledDialog,
} from "../../style";
import Button from "../../../Button";

export default function ErrorDialog({ data = {} }) {
  const ref = useRef();
  const { t, toggleDialog } = useContext(DialogModel.Context);

  const { props = {}, id = "" } = data || {};

  const {
    title = "",
    text = "",
    confirmButtonText = t("button.confirm"),
    titleStyle,
    textStyle,
    containerStyle,
    remark,
    remarkStyle,
  } = props || {};

  useEffect(() => {
    const currentModal = ref?.current;

    if (currentModal?.open) {
      return;
    }

    if (currentModal) {
      ref.current.showModal();
    }
  }, []);

  return (
    <StyledDialog ref={ref} icon="error">
      <BasicContainer icon="true" style={containerStyle}>
        <IconDiv>
          <Player
            autoplay
            src="https://lottie.host/9d439b9d-2a66-44aa-ac89-4c387eab485a/JRxYcyfmAs.json"
            style={{ height: "140px", width: "140px" }}
            keepLastFrame
            speed={2}
          />
        </IconDiv>

        <Title style={titleStyle} dangerouslySetInnerHTML={{ __html: title }} />
        <Text style={textStyle}>{text}</Text>
        {remark && <Remark style={remarkStyle}>{remark}</Remark>}
        <Button
          style={{ marginTop: 10 }}
          onClick={() => {
            toggleDialog({ open: false }, id);
          }}
        >
          {confirmButtonText}
        </Button>
      </BasicContainer>
    </StyledDialog>
  );
}
